/* ComponentAppBanner template */
import { Host, h, FunctionalComponent } from '@stencil/core'; // eslint-disable-line @typescript-eslint/no-unused-vars
import { PlaceholderIcons } from '@cewe-designsystem/util_placeholder_icons';
import { InfoBarComponent } from './cwc-info-bar';

/**
 * Definition of  parameters that the template needs to work.
 */
interface InfoBarTemplateProps {
  /**
   * The class instance that provides controller functionality for the template
   */
  controller: InfoBarComponent;
  // Specify parameters that are required to be passed down to the template here.
}

const InfoBarTemplate: FunctionalComponent<InfoBarTemplateProps> = ({ controller }) => (
  <Host style={!controller.opened ? { display: 'none' } : {}}>
    <div class="wrapper">
      <div class="inner">
        <slot></slot>
      </div>
      {controller.isClosable ? (
        <close-btn onClick={() => controller.onClose()}>
          <slot name={'close-icon'}>
            <svg viewBox={'0 0 24 24'}>{PlaceholderIcons.close()}</svg>
          </slot>
        </close-btn>
      ) : (
        ''
      )}
    </div>
  </Host>
);

export default InfoBarTemplate;
